import fromDtoToStylist from 'dto/stylist/fromDtoToStylist.dto';

const fromDtosToStylists = (array) => (Array.isArray(array) ? array.map(fromDtoToStylist) : []);

export default fromDtosToStylists;
